import { Injectable } from '@angular/core';
import { StatsigClient, StatsigUser } from '@statsig/js-client';

import { environment } from '@environment';

@Injectable()
export class StatsigExperimentsService {

  public attributes: {[key: string]: string} = {country: environment.countryInfo.iso_code};

  constructor() {
  }

  public async initStatsig(
    userID: string,
    experiments: string[], 
    attributes?: {[key: string]: string | number | boolean}
  ): Promise<{name: string, treatment: boolean}[]> {
    const user: StatsigUser = { 
      userID,
      country: environment.countryInfo.iso_code, 
      custom: attributes,
      customIDs: {country_user_id: `${environment.countryInfo.iso_code}_${userID}`}
    };
    const myStatsigClient = new StatsigClient(
      environment.statsigKey, 
      user,
      { environment: { tier: environment.production ? 'production' : 'development' }}
    );
    let _experiments = [];
    await myStatsigClient.initializeAsync();
    experiments.forEach(experiment => {
      const treatment = myStatsigClient.getExperiment(experiment).get('treatment') || false;
      _experiments.push({name: experiment, treatment})
    })
    return _experiments;
  }
}
